/**
 * Shared image URL helper.
 *
 * Priority:
 *   1. REACT_APP_CLOUDINARY_BASE_URL (primary — set in .env)
 *   2. CloudFront CDN (legacy fallback)
 *
 * If the provided key is already a full URL (starts with "http"),
 * it is returned as-is so legacy data still renders correctly.
 *
 * Usage:
 *   getImageUrl('okmaguwcbb8m1h7jpwzx.jpg')
 *   // => 'https://res.cloudinary.com/.../okmaguwcbb8m1h7jpwzx.jpg'
 */

const CLOUDINARY_BASE_URL =
    process.env.REACT_APP_CLOUDINARY_BASE_URL ||
    'https://res.cloudinary.com/di1dlqzh0/image/upload/v1771691256/';

const CLOUDFRONT_BASE_URL = 'https://d2uw10xs7zocn6.cloudfront.net/';

/**
 * Returns a fully-qualified image URL.
 * @param key - Either a raw Cloudinary/CloudFront key or an already-absolute URL.
 * @param fallback - Optional fallback string to return when key is empty.
 */
export function getImageUrl(key: string | null | undefined, fallback = ''): string {
    if (!key) return fallback;

    // Already an absolute URL — return as-is (covers both Cloudinary and CloudFront full URLs)
    if (key.startsWith('http://') || key.startsWith('https://')) return key;

    // Raw key — prepend Cloudinary (primary), CloudFront is legacy fallback
    return `${CLOUDINARY_BASE_URL}${key}`;
}

/**
 * Legacy alias kept for backward-compatibility.
 * Prefer getImageUrl() in new code.
 */
export function toAbsUrl(url: string | null | undefined): string {
    return getImageUrl(url);
}
